<template>
  <div class="content content--ideas">
    <MyHeader :breadcrumbItems="[

        {
          name:  ideaBoardSection.value,
          path: `/${$route.params.companySlug}/ideas`
        }
      ]"/>

    <header class="content-header d-lg-none">
      <h1>Idea board</h1>
      <router-link :to="{name: 'AddIdea'}" class="button-icon-simple"><i class="icon-plus"></i></router-link>
    </header>

    <section class="section section--ideas-slider">
      <div class="container">
        <h1>{{ideaBoardSection.value}}</h1>
<!--        <div class="row">-->
<!--          <div class="col-lg-8 offset-lg-2">-->
<!--            <p>This is the place where you can share your ideas easily. Please share any ideas that may help us solve customer problems, or ideas that will improve our SAP offerings portfolio, or differentiate Capgemini in the market. Welcome to our community!</p>-->
<!--          </div>-->
<!--        </div>-->
      </div>

      <Slider :slides="slides" :my-class="'slider-container'" cols="1" v-if="slides.length">
        <template v-slot:slide="{ slide }" :type="'paginator'">
          <IdeaHeroBox :idea="featuredIdeas[slide]" />
        </template>
      </Slider>
    </section>

<!--    <div class="tabs-header">-->
<!--      <h2>Browse Idea Board by</h2>-->
<!--    </div>-->
    <div class="container section--button-wrapper">
      <router-link  :to="{name: 'AddIdea'}" class="button-icon">Add new idea <i class="icon-plus-circle"></i></router-link>
    </div>

    <!--    <div class="tabs">-->
<!--      <div class="tabs-inner">-->
<!--        <router-link :to="{name: 'IdeasTab'}" exact active-class="active">Ideas <span class="tab-number">{{countIdeas}}</span></router-link>-->
<!--      </div>-->
<!--    </div>-->

    <div class="container main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import Slider from "@/components/general/Slider";
import IdeaHeroBox from "@/components/ideas/IdeaHeroBox";
import settings from "@/settings";
import settingUser from "@/api/settingUser";
import moment from "moment";

export default {
  name: "Ideas",
  components: {IdeaHeroBox, Slider, MyHeader},
  data() {
    return {
    }
  },
  mounted() {
    this.getFeaturedIdeas()
    window._paq.push(['setDocumentTitle', this.ideaBoardSection.value]);
    window._paq.push(['trackPageView']);
    this.updateNotificationDate();
  },
  computed: {
    slides () {
      return this.featuredIdeas.map((idea, index) => index)
    },
    countIdeas() {
      return this.$store.getters.ideasCount
    },
    countChallenges() {
      return 0
    },
    featuredIdeas() {
      return this.$store.getters.featuredIdeas
    },
    ideaBoardSection() {
      return this.$store.getters.sectionByCode(settings.MODULES.IDEA_BOARD)
    }
  },

  methods: {
    updateNotificationDate() {
      settingUser.createSettingUser({
        idUser: this.$store.getters.user.idUser,
        idSettingCompany: this.ideaBoardSection.idSettingCompany,
        valueDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      }, () => {
        this.$store.dispatch('updateNotification', this.ideaBoardSection.idSettingCompany)
        this.$store.dispatch('getUserInfo')
      })
    },
    getFeaturedIdeas() {
      let params = {
        _embed: 1,
        _idType: this.ideaBoardSection.idSettingCompany,
        _page: 1,
        _per_page: 20,
        _sort: 'date'
      }
      this.$store.dispatch('getFeaturedIdeas', params)
    }
  }
}
</script>

<style scoped>

</style>
